import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchChannelOrderStatus = createAsyncThunk("fetchChannelOrderStatus", async ({ identifier }) => {
	const response = await axiosHttp.get(`statuses?keyword=${identifier}`);
	return response.data.data;
});

const GlobalChannelsOrderStatusSlice = createSlice({
	name: "GlobalChannelsOrderStatusSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchChannelOrderStatus.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchChannelOrderStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchChannelOrderStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default GlobalChannelsOrderStatusSlice.reducer;

// import axiosHttp from "services/axiosHttp";
// const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// //action
// export const fetchChannelStatus = createAsyncThunk("fetchChannelStatus", async ({ identifier }) => {
// 	const response = await axiosHttp.get(`status/list?identifier=${identifier}`);
// 	return response.data.data;
// });

// const ChannelStatusSlice = createSlice({
// 	name: "ChannelStatusSlice",
// 	initialState: {
// 		isLoading: false,
// 		data: null,
// 		error: null,
// 	},

// 	extraReducers: (builder) => {
// 		builder.addCase(fetchChannelStatus.pending, (state, action) => {
// 			state.isLoading = true;
// 		});

// 		builder.addCase(fetchChannelStatus.fulfilled, (state, action) => {
// 			state.isLoading = false;
// 			state.data = action.payload;
// 		});
// 		builder.addCase(fetchChannelStatus.rejected, (state, action) => {
// 			state.isLoading = false;
// 			state.error = action.payload;
// 		});
// 	},
// });

// export default ChannelStatusSlice.reducer;
